export default "__VITE_ASSET__BayLKHcr__"